module.exports = __webpack_public_path__ + "static/media/urbangoo07.37ee5865.webp";